var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { COLORS } from '../../../constants/colors';
export const CloudUp = (_a) => {
    var { stroke, fill } = _a, rest = __rest(_a, ["stroke", "fill"]);
    return (_jsx("svg", Object.assign({ width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: _jsx("path", { d: "M10.54 15.1133C6.47504 15.6683 3.33337 19.1166 3.33337 23.3333C3.33337 27.9349 7.06504 31.6666 11.6667 31.6666H30C33.6817 31.6666 36.6667 28.6816 36.6667 24.9999C36.6667 21.3183 33.6817 18.3333 30 18.3333C30 12.8099 25.5234 8.33325 20 8.33325C15.605 8.33325 11.8817 11.1716 10.54 15.1133ZM16.3884 21.1117L20.0001 17.5L23.6118 21.1117M20 25.8333V17.5", stroke: stroke !== null && stroke !== void 0 ? stroke : COLORS.PURPLE[900], strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) })));
};
